import React from "react";
import { twMerge } from "tailwind-merge";

import AppTable from "components/Shared/AppTable";

import { useLazyListMetricsQuery } from "store/services/metricApi";

import { useAuth } from "hooks";

import { localizeDateShort } from "utils/dateFormats";
import { useCustomParams } from "hooks/useCustomParams";

const APIMetrics = () => {
  const { loggedInUser } = useAuth();

  const { params } = useCustomParams();

  const { page = 1, perPage = 10 } = params;

  const STATUS_INDICATOR_MAP = {
    2: "bg-green-500 text-green-50",
    3: "bg-blue-500 text-blue-50",
    4: "bg-orange-500 text-orange-50",
    5: "bg-red-500 text-red-100",
  };

  const columns = [
    {
      name: "Endpoint",
      selector: (row) => row?.endpoint,
      minWidth: "400px",
    },
    {
      name: "Method",
      selector: (row) => row?.method,
    },
    {
      name: "Status Code",
      cell: (row) => {
        const indicatorIndex = row?.statusCode?.toString()?.charAt(0);
        const indicatorClasses = STATUS_INDICATOR_MAP[indicatorIndex] || "";

        return (
          <div
            className={twMerge(
              "rounded px-1.5 py-0.5 text-sm",
              indicatorClasses
            )}
          >
            {row?.statusCode}
          </div>
        );
      },
    },
    {
      name: "Response Time",
      cell: (row) => Number(row?.responseTime)?.toPrecision(4) + " ms",
    },
    {
      name: "Request Date",
      cell: (row) => localizeDateShort(row?.createdAt),
    },
  ];

  // RTK Query
  const [fetchMetrics, { data: metricRes, isLoading, isFetching }] =
    useLazyListMetricsQuery();

  React.useEffect(() => {
    fetchMetrics({
      page,
      limit: perPage,
      sourceRef: loggedInUser?.typeRef,
    });
  }, [fetchMetrics, loggedInUser?.typeRef, page, perPage]);

  return (
    <AppTable
      data={metricRes?.data ?? []}
      columns={columns}
      progressPending={isLoading || isFetching}
      paginationTotalRows={metricRes?.totalItems ?? 0}
    />
  );
};

export default APIMetrics;
